import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CommonService } from '../../common-service';
import { environment } from '../../../../../environments/environment';
import { UsuarioResponse } from '../../responses/usuario/usuario.response';

@Injectable({
    providedIn: "root"
})
export class UsuarioService extends CommonService {
    constructor(
        private router: Router,
        private httpClient: HttpClient
    ) {
        super();
    }

    public getPorEmail(email: string): Observable<UsuarioResponse> {
        return this.httpClient
            .get<UsuarioResponse>(environment.urlApiUsuario + `Usuario/email/${email}`, {
                headers: this.addHeaderToken().headers,
            }).pipe(catchError(this.handleError));
    }
}